import { render, staticRenderFns } from "./BiliLive.vue?vue&type=template&id=7410d71a&"
import script from "./BiliLive.vue?vue&type=script&lang=js&"
export * from "./BiliLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports